<template>
  <v-card>
    <v-card-title>
      Error in GL Import Fund(s) not found.
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="glError"
        :items-per-page="100"
        :hide-default-footer="true"
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'HandleGlError',
  props: {
    glErrors: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    headers: [
      { text: 'Fund', value: 'fund' },
      { text: 'Fund AltKey', value: 'fundAltKey' },
      { text: 'Bank AltKey', value: 'bankAltKey' },
      { text: 'Fund Description', value: 'description' },
    ],
  }),
  computed: {
    glError() {
      const value = this.glErrors.length > 0 ? this.glErrors : [];
      return value;
    },
    isErrorWithHeader() {
      return this.errorMode === 'errorWithHeader';
    },
  },
  methods: {
    proceedImportFile() {
      this.$emit('proceedImportFile', true);
    },
  },
};
</script>
